import { useContext } from 'react';
import { ResultsInterface } from '../../lib/type';
import { layoutContext } from '../LeaderAssesssment';
import LeaderResults from './LeaderResults';
import LearnerResults from './LearnerResults';

interface resultsProps {
  contents: ResultsInterface;
}

const Results = (resultsProps: resultsProps) => {
  const { score } = useContext(layoutContext);
  console.log(score);
  const { contents } = resultsProps;
  if (score > 75) {
    return <LeaderResults contents={contents} />;
  } else {
    return <LearnerResults contents={contents} />;
  }
};

export default Results;
